import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { HeaderGuestMenuToggleButton } from '@/components/modules/Layout/Header/Guest/Button/HeaderGuestMenuToggleButton';
import { HeaderGuestMenuDrawer } from '@/components/modules/Layout/Header/Guest/List/HeaderGuestMenuDrawer';
import { Logo } from '@/components/ui/Image/SvgImage/Logo';
import { Overlay } from '@/components/ui/Surface/Overlay';
import { useBoolState } from '@/hooks/state/useBoolState';
import { stringifyUrl } from '@/utils/libs/query-string/stringify';
import { TOP_SECTION_IDS } from '@/utils/page/top';
import { caseListPath, columnListPath, companyPath, forConsultantTopPath, topPath, } from '@/utils/router/links';
/** メインメニューリンク一覧 */
const mainMenus = [
    {
        path: stringifyUrl({
            fragmentIdentifier: TOP_SECTION_IDS.serviceFlow,
            url: topPath(),
        }),
        text: 'サービスの流れ',
    },
    {
        path: caseListPath(),
        text: '選定支援事例',
    },
    {
        path: stringifyUrl({
            fragmentIdentifier: TOP_SECTION_IDS.userVoice,
            url: topPath(),
        }),
        text: 'ユーザーの声',
    },
    { path: columnListPath(), text: '資料・コラム・セミナー' },
];
/** サブメニューリンク一覧 */
const subMenus = [
    { path: forConsultantTopPath(), text: 'コンサルタントの方へ' },
    { path: companyPath(), text: '運営会社について' },
];
export const GuestHeader = (props) => {
    const { className, logoClassName = '', onClickGuestHeaderMenu, viewMode, } = props;
    const isNormal = viewMode === 'normal';
    const isExpand = viewMode === 'expand';
    const { boolState: isOpenMenu, changeFalse: hideMenu, changeToggle: toggleMenu, } = useBoolState();
    return (_jsx("header", Object.assign({ className: clsx(className, 'h-[60px] md:h-[80px]', 'after:content-[""]', 'after:absolute after:inset-0', 'after:z-10', 'after:shadow-lg', 'after:pointer-events-none') }, { children: _jsxs("div", Object.assign({ className: clsx('flex', 'flex-row items-center', 'relative', 'h-full', 'px-20', 'bg-white', 'z-20 lg:z-0', isExpand && clsx('lg:px-64'), isNormal && clsx('lg:gap-x-32', 'lg:px-32')) }, { children: [_jsx(RouterLink, Object.assign({ to: topPath() }, { children: _jsx(Logo, { className: clsx('flex shrink-0', 'w-[120px]', 'h-[30px]', isExpand && clsx('lg:w-[180px]', 'lg:h-[45px]'), logoClassName), color: 'primary' }) })), _jsx(HeaderGuestMenuToggleButton, { className: clsx('ml-auto', 'lg:hidden'), isOpen: isOpenMenu, onClickMenu: toggleMenu }), _jsx(Overlay, { className: clsx('z-10 lg:hidden'), isShow: isOpenMenu, onClick: hideMenu, opacity: 'light' }), _jsx("div", Object.assign({ className: clsx('fixed', 'top-0', 'bottom-0', 'right-0', 'bg-white lg:bg-transparent', 'max-lg:transition-[transform]', 'z-50', isOpenMenu ? 'max-lg:translate-x-0' : 'max-lg:translate-x-[110%]', isNormal && clsx('lg:static lg:flex-grow', 'lg:h-full'), isExpand &&
                        clsx('lg:absolute', 'lg:top-[80px]', 'lg:left-0', 'lg:bottom-auto', 'lg:h-64')) }, { children: _jsx(HeaderGuestMenuDrawer, { className: clsx(isExpand && 'lg:pl-64'), hideMenu: hideMenu, mainMenus: mainMenus, onClickMenu: onClickGuestHeaderMenu, subMenus: subMenus, viewMode: viewMode }) }))] })) })));
};
